export default {
  questionnaire: {
    porseshnamehList: "v1/fa/porseshnameh/porseshnameh",
    porseshnamehDetail: "v1/fa/porseshnameh/porseshnameh/{0}",
    porseshnamehPageList: "v1/fa/porseshnameh/porseshnameh/{0}/page",
    porseshnamehPageDetail: "v1/fa/porseshnameh/porseshnameh/{0}/page/{1}",
    questionnairePage: "v1/fa/porseshnameh/porseshnameh-page",
    questionnairePageByCode: "v1/fa/porseshnameh/porseshnameh-page/{0}",
    adminPorseshnamehPageItemList:
      "v1/fa/porseshnameh/admin-porseshnameh/{0}/page/{1}/item",
    porseshnamehPageItemList:
      "v1/fa/porseshnameh/porseshnameh/{0}/page/{1}/item",
    porseshnamehPageItemListByAzmoonExecutePersonCode:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/porseshnameh/{1}/page/{2}/item",
    azmoonExecutePersonPorseshnamehItem:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/porseshnameh-item/{1}",
    azmoonExecutePersonPorseshnamehItemAttachment:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/porseshnameh-item/{1}/page-repeat/{2}/attachment-answer/{3}",
    porseshnamehPageItemDetail:
      "v1/fa/porseshnameh/porseshnameh/{0}/page/{1}/item/{2}",
    questionnaireItem: "v1/fa/porseshnameh/porseshnameh-item",
    questionnaireItemByCode: "v1/fa/porseshnameh/porseshnameh-item/{0}",
    questionnaireItemAttachment:
      "v1/fa/porseshnameh/porseshnameh-item/{0}/attachment/{1}",
    questionnaireAnswerAttempts:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/porseshnameh/{1}/answer-attempts",
    questionnaireAnswerAttempt: "v1/fa/porseshnameh/answer-attempt/{0}",
    questionnaireFinish:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/attempt/{1}/finish",
    questionnairePageRepeat:
      "v1/fa/porseshnameh/azmoon-execute-person/{0}/attempt/{1}/porseshnameh-page/{2}/page-repeat",
    pageRepeatId: "v1/fa/porseshnameh/page-repeat/{0}",
  },
};
